export class RouteColor {
  route: string;
  color: string;

  constructor(r: string, c: string) {
    this.route = r;
    this.color = c;
  }
}
